/**
 * Helper function to safely get and parse user JSON object
 * 
 * @returns object|null - Returns user object if it exists or null if not
 */
export const getLocalUser = () => {
    let user = null;

    try {
        user = JSON.parse(localStorage.getItem('user'));
    }
    catch(error) {
        console.warn(error);
    }

    return user;
}

export const getLangCode = (langName) => {
    const langCodes = {
        'english' : 'en',
        'spanish' : 'es',
        'german' : 'de',
        'french' : 'fr',
    }

    return langCodes[langName];
}

export const getLangFromCode = (code) => {
    const langCodes = {
        'en' : 'english',
        'es' : 'spanish',
        'de' : 'german',
        'fr' : 'french',
    }

    return langCodes[code];
}